export function calculateAspectRatioDecimal(): number {
    const hasScreenDimensions = !!window.screen && !!window.screen.width && !!window.screen.height;
    const width = hasScreenDimensions ? window.screen.width : innerWidth;
    const height = hasScreenDimensions ? window.screen.height : innerHeight;
    const smallerDimension = Math.min(width, height);
    const largerDimension = Math.max(width, height);
    const aspectRatio = largerDimension / smallerDimension;
    return aspectRatio;
}